import { useEffect } from 'react';
import { Event } from '@bizzabo/entities';
import { useFeatureToggle } from '@bizzabo/feature-toggle-client';

const zendeskUrl =
    'https://static.zdassets.com/ekr/snippet.js?key=30b6aeec-324c-4809-8d1c-e5a72b82651c';

const useZendesk = (event: Event, embedMode: boolean) => {
    const isSupportedEvent = useFeatureToggle('zendesk', false);

    useEffect(() => {
        if (!isSupportedEvent || embedMode) {
            return;
        }
        const script = document.createElement('script');
        script.src = zendeskUrl;
        script.id = 'ze-snippet';
        script.async = true;
        document.body.appendChild(script);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.zESettings = {
            webWidget: {
                position: { horizontal: 'left', vertical: 'bottom' },
                color: { theme: '#8C8C8C' },
                launcher: {
                    chatLabel: {
                        '*': 'Support',
                    },
                },
            },
        };
        return () => {
            document.body.removeChild(script);
        };
    }, [event?.uniqueName]);
};

export default useZendesk;
